import { guardUnspecified, guardEmptyString } from '@portal/utils/util-guards';

const notEmpty = (input?: string | null) =>
  guardUnspecified(input) && guardEmptyString(input);

type ScriptParams = {
  src?: string;
  content?: string;
  id?: string;
};

const injectedScripts: Set<string> = new Set();

export const injectScript = (
  scriptParams: ScriptParams,
  async = true
): Promise<HTMLScriptElement> => {
  return new Promise<HTMLScriptElement>((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = async;

    if (notEmpty(scriptParams.id)) {
      script.id = scriptParams.id as string;
    }

    if (!notEmpty(scriptParams.src) && !notEmpty(scriptParams.content)) {
      reject();
      return;
    }

    if (notEmpty(scriptParams.src) && !injectedScripts.has(scriptParams.src as string)) {
      script.src = scriptParams.src as string;
      script.onload = () => {
        injectedScripts.add(script.src);
        resolve(script);
      };
      script.onerror = e => {
        reject(e);
      };
    }

    if (notEmpty(scriptParams.content)) {
      script.innerHTML = scriptParams.content as string;

      if (!notEmpty(scriptParams.src)) {
        resolve(script);
      }
    }

    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

export const getPreloadImageString = (
  url: string,
  type: string,
  media: string,
  srcset?: string
) =>
  `<link rel="preload" href="${url}" as="image" type="${type}" media="${media}"${
    guardUnspecified(srcset) ? ' imagesrcset="' + srcset + '"' : ''
  }>`;
